import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { DelegationsService } from '../../common/_services/delegations.service';
import { Delegation } from '../../common/_types/delegation';
import { ColectiveAgreement } from '../../common/_types/colective-agreement';
import { ColectiveAgreementsService } from '../../common/_services/colective-agreements.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-colective-agreement-list',
    templateUrl: './colective-agreement-list.component.html',
    styleUrls: ['./colective-agreement-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class ColectiveAgreementListComponent {
  public colectiveAgreements: ColectiveAgreement[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  public lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private colectiveAgreementsService: ColectiveAgreementsService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService,
  ) {
   
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Convenios Colectivos");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as ColectiveAgreement);
    });
    this.allowWrite = this.loginService.hasPermission("COLECTIVE_AGREEMENT.WRITE")
    this.allowDelete = this.loginService.hasPermission("COLECTIVE_AGREEMENT.DELETE")
  }

  public async loadData($event: any) {
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.colectiveAgreementsService.all(params));
    this.colectiveAgreements = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(colectiveAgreement: ColectiveAgreement | null, source?: string) {
    this.router.navigate(['colective-agreements/' + (colectiveAgreement && Object.keys(colectiveAgreement).length > 0 ? colectiveAgreement.id : 0) + (source ? '/' + source : '')]);
  }

  delete(colectiveAgreement: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el convenio colectivo?",
        header: "Eliminar convenio colectivo",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.colectiveAgreementsService.delete(colectiveAgreement.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Convenio colectivo eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
